import { defineComponent as _defineComponent } from 'vue'
import FormButton from '@/components/base/FormButton.vue'
    import DocumentRenderModal from '@/components/DocumentRenderModal.vue'
    import { ValidationObserver } from 'vee-validate'
    import FormContainer from '@/components/base/FormContainer.vue'
    import Modal from '@/components/Modal.vue'
    import { computed, ref, watch } from 'vue'
    import FormFieldSsn from 'aven_shared/src/vue2/components/FormFieldSsn'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentRender',
  props: {
    docType: null,
    documentTitle: null,
    ssnProtected: { type: Boolean },
    show: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
            (e: 'close'): void
        }), expose: any, slots: any, attrs: any }) {

const props = __props as {
            docType: string
            documentTitle: string
            ssnProtected: boolean
            show: boolean
        }

    

    

    const ssnModalOpen = ref(false)
    const documentRenderModalOpen = ref(false)
    const ssnObserverRef = ref<InstanceType<typeof ValidationObserver>>()
    const ssn = ref<string>('')
    const shouldShow = computed(() => {
        return props.show
    })
    const submitting = ref(false)

    watch(shouldShow, (newVal) => {
        if (newVal) {
            if (props.ssnProtected) {
                ssnModalOpen.value = true
            } else {
                documentRenderModalOpen.value = true
            }
        } else {
            ssnModalOpen.value = false
            documentRenderModalOpen.value = false
        }
    })

    const onSubmit = async () => {
        ssnModalOpen.value = false
        documentRenderModalOpen.value = true
    }

    const onClose = () => {
        emit('close')
    }

    const onSsnInput = (value: string) => {
        ssn.value = value
        console.log('ssn', ssn.value)
    }

return { __sfc: true,props, emit, ssnModalOpen, documentRenderModalOpen, ssnObserverRef, ssn, shouldShow, submitting, onSubmit, onClose, onSsnInput, FormButton, DocumentRenderModal, ValidationObserver, FormContainer, Modal, FormFieldSsn }
}

})